import React, { useEffect, useState } from "react";

import styled from "styled-components";
import {
  CardTitle,
  CommonFlex,
  CommonText,
  Container,
  ContentHeader,
  PageTitle,
} from "../../../styledComponents/common";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import solidCircleIcon from "../../../assets/img/icons/solid_circle_button.svg";
import borderCircleIcon from "../../../assets/img/icons/border_circle.svg";
import Select from "../../../components/ReactSelectDropdown";
import FilterDropDownStyle from "../../../components/DropdownStyle/FilterDropDownStyle";

const CircleIcon = styled.img`
  width: 30px;
  height: 30px;
  cursor: pointer;
`;

const DateTimeSettings = (props) => {
  const {
    isLoading,
    selectedOrganization,
    updateDateFormat,
    getDateFormat,
    dateFormat,
    isDateFormatUpdated,
    updateStartDayOfWeek,
    startDayOfWeek,
    history
  } = props;

  const [activeCirle, setActiveCircle] = useState(null);


  const dateString = [
    { label: "dd/mm/yyyy (e.g 18/02/2019)", value: "DD/MM/YYYY" },
    { label: "mm/dd/yyyy (e.g 02/18/2019)", value: "MM/DD/YYYY" },
    { label: "yyyy/mm/dd (e.g 2019/02/18)", value: "YYYY/MM/DD" },
  ];

  const weekDays = [
    { label: "Sunday", value: "sunday" },
    { label: "Monday", value: "monday" },
    { label: "Tuesday", value: "tuesday" },
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
  ];
  const [startDay, setStartDay] = useState("monday");

  useEffect(() => {
    if (selectedOrganization?.configuration?.start_day_of_week) {
      setStartDay(selectedOrganization.configuration.start_day_of_week);
    }
  }, [selectedOrganization?.configuration?.start_day_of_week]);

  useEffect(() => {
    if (selectedOrganization?.configuration?.id) {
      const payload = {
        configuration_id: selectedOrganization.configuration.id,
        organization_id: selectedOrganization.id,
      };
      getDateFormat(payload);
    }
  }, [selectedOrganization?.id]);

  useEffect(() => {
    if (dateFormat) {
      const index = dateString.findIndex((item) => item.value === dateFormat);
      setActiveCircle(index);
    }
  }, [selectedOrganization, dateFormat]);
  
  useEffect(() => {
    if (startDayOfWeek) {
      setStartDay(startDayOfWeek);
    }
  }, [startDayOfWeek]);

  const handleDateFormatUpdate = (index) => {
    const payload = {
      date_format: dateString[index].value,
      configuration_id: selectedOrganization.configuration.id,
      organization_id: selectedOrganization.id,
    };
    updateDateFormat(payload);
  };

  const handleStartDayUpdate = (day) => {
    if (day === startDay || !day) return;
    const payload = {
      start_day_of_week: day,
      organization_id: selectedOrganization.id,
      configuration_id: selectedOrganization.configuration.id,
    };
    updateStartDayOfWeek(payload);
  };

  return (
    <div className="content">
      {/* <PageTitle>Date & Time Settings</PageTitle> */}
      <ContentHeader>
        <BackButtonComponent
          onClick={() => history.push("/user/settings")}
          subTitle="Back to settings"
        />
      </ContentHeader>

      {(selectedOrganization?.role === "owner" ||
        selectedOrganization?.role === "admin") && (
        <Container
        marginTop="12px"
          padding="30px"
          style={{
            overflow: "visible",
          }}
        >
          {isLoading ? (
            <ComponentCircleLoader />
          ) : (
            <>
              <CardTitle>Date & Time Settings</CardTitle>
              <Container padding="30px">
                {dateString.map((item, index) => (
                  <CommonFlex gap="10px" key={index}>
                    <CircleIcon
                      src={
                        index == activeCirle
                          ? solidCircleIcon
                          : borderCircleIcon
                      }
                      alt="icon"
                      onClick={() => handleDateFormatUpdate(index)}
                    />
                    <CommonText margin="0">{item.label}</CommonText>
                  </CommonFlex>
                ))}
              </Container>
              <Container
                padding="30px"
                style={{
                  overflow: "visible",
                }}
              >
                <CommonText margin="0 0 10px 0" style={{ fontWeight: 500 }}>
                  Start Day of Week
                </CommonText>
                <div style={{ width: "150px" }}>
                  <Select
                    isSearchable={false}
                    value={weekDays.find((day) => day.value === startDay)}
                    options={weekDays}
                    placeholder="Start Day"
                    onChange={(option) => handleStartDayUpdate(option.value)}
                    styles={FilterDropDownStyle({
                      height: "40px",
                      width: "130px",
                      menuWidth: "130px",
                    })}
                  />
                </div>
              </Container>
            </>
          )}
        </Container>
      )}
    </div>
  );
};

export default DateTimeSettings;
